<template>
  <div>
    <v-row v-for="(faixa, indice) in value" :key="faixa.chave" dense class="align-start">
      <v-col cols="12" sm="3">
        <ValidationProvider
          :name="`Data do ${indice + 1}º desconto`"
          :rules="{
            required: true,
            data_no_periodo: { inicio, fechamento },
            data_unica: { outras: datasDasOutrasFaixas(indice) },
          }"
          v-slot="{ errors }"
        >
          <e-label>Data do {{ indice + 1 }}º desconto</e-label>
          <v-text-field
            v-model="faixa.data"
            type="date"
            :min="inicio"
            :max="fechamento"
            :disabled="disabled"
            :error-messages="errors"
            dense
            solo
          />
        </ValidationProvider>
      </v-col>
      <v-col cols="12" sm="4">
        <ValidationProvider
          name="Desconto para matriculado"
          rules="required|min_value:0"
          v-slot="{ errors }"
        >
          <e-label>Desconto: aluno matriculado no ano anterior</e-label>
          <v-currency-field
            v-model="faixa.desconto_matriculado"
            :allow-negative="false"
            :disabled="disabled"
            :error-messages="errors"
            prefix="R$"
            dense
            solo
          />
        </ValidationProvider>
      </v-col>
      <v-col cols="12" sm="4">
        <ValidationProvider
          name="Desconto para não matriculado"
          rules="required|min_value:0"
          v-slot="{ errors }"
        >
          <e-label>Desconto: aluno não matriculado no ano anterior</e-label>
          <v-currency-field
            v-model="faixa.desconto_nao_matriculado"
            :allow-negative="false"
            :disabled="disabled"
            :error-messages="errors"
            prefix="R$"
            dense
            solo
          />
        </ValidationProvider>
      </v-col>
      <v-col cols="12" sm="1" class="d-flex align-center pt-sm-7">
        <v-btn
          v-if="!disabled"
          icon
          color="error"
          :aria-label="`Remover ${indice + 1}º desconto`"
          @click="remover(indice)"
        >
          <v-icon small>fa fa-trash</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <p v-if="value.length === 0" class="grey--text">
      Nenhuma faixa de desconto: as pré-matrículas deste período pagam o valor cheio da matrícula.
    </p>

    <v-btn
      v-if="!disabled"
      small
      outlined
      color="primary"
      :disabled="value.length >= maximoDeFaixas"
      @click="adicionar"
    >
      <v-icon small left>fa fa-plus</v-icon>
      {{ value.length >= maximoDeFaixas ? "Máximo de 3 faixas" : "Adicionar faixa de desconto" }}
    </v-btn>
  </div>
</template>

<script>
import { extend } from "vee-validate";

// O banco (Sicoob) aceita no máximo três datas de desconto por boleto.
const MAXIMO_DE_FAIXAS = 3;

// Datas no formato AAAA-MM-DD comparam corretamente como texto.
extend("data_no_periodo", {
  params: ["inicio", "fechamento"],
  validate: (data, { inicio, fechamento }) =>
    !inicio || !fechamento || (data >= inicio && data <= fechamento),
  message: "A data do desconto deve estar dentro do período.",
});

extend("data_unica", {
  params: ["outras"],
  validate: (data, { outras }) => !outras.includes(data),
  message: "Não pode haver duas faixas de desconto na mesma data.",
});

let proximaChave = 0;

/**
 * Faixas de desconto do período. Cada faixa adicionada exige data e os dois valores, então
 * não existe faixa vazia entre duas preenchidas: o preenchimento é sempre em ordem.
 * Desconto zero é aceito.
 */
export default {
  name: "EFaixasDeDesconto",
  props: {
    value: { type: Array, required: true },
    inicio: { type: String, default: null },
    fechamento: { type: String, default: null },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return { maximoDeFaixas: MAXIMO_DE_FAIXAS };
  },
  methods: {
    datasDasOutrasFaixas(indice) {
      return this.value.filter((_, i) => i !== indice).map((faixa) => faixa.data);
    },
    adicionar() {
      if (this.value.length >= MAXIMO_DE_FAIXAS) return;
      proximaChave += 1;
      this.$emit("input", [
        ...this.value,
        {
          chave: `nova-${proximaChave}`,
          data: null,
          desconto_matriculado: null,
          desconto_nao_matriculado: null,
        },
      ]);
    },
    remover(indice) {
      this.$emit(
        "input",
        this.value.filter((_, i) => i !== indice)
      );
    },
  },
};
</script>
